<template>
  <div class="request-page">
      <h3>
        <slot v-if="propType == 'bonus'">Deneme Bonusu</slot>
        <slot v-if="propType == 'discount'">Discount</slot>
        Al
      </h3>

      <slot v-if="propType == 'bonus'">
        <br>
        <div class="row">
          <div class="col" v-if="!_.isNull(config.bonus_button.options.cash)">
            <button class="button secondary" style="width:100%" :class="{ 'primary' : type == 'freebet'}" @click="type = 'freebet'">{{ config.bonus_button.options.cash }} TL Nakit</button>
          </div>
          <div class="col" v-if="!_.isEmpty(config.bonus_button.options.freespin)">
            <button class="button secondary" style="width:100%" :class="{ 'primary' : type == 'freespin'}" @click="type = 'freespin'">
              {{ config.bonus_button.options.freespin.count }}
              {{ config.bonus_button.options.freespin.game_name }}
              Freespin</button>
          </div>
        </div>
        <slot v-for="item in config.bonus_button.rules">
          <div class="alert">{{ item }}</div>
        </slot>
      </slot>

        <h5 v-if="propType == 'discount'">
          <div class="row">
            <div class="col">
              <button class="button secondary" style="width:100%" :class="{ 'primary' : percent == '10'}" @click="percent = '10'">%10 (Sınır Yok)</button>
            </div>
            <div class="col">
              <button class="button secondary" style="width:100%" :class="{ 'primary' : percent == '20'}" @click="percent = '20'">%20 Casino / Spor</button>
            </div>
          </div>
          <div class="alert">Discount alabilmeniz için bakiyenizin <span>maksimum 10TL olması gerekmektedir.</span></div>
          <div class="alert">Sistem ekleme yapmıyorsa hakkınız yoktur lütfen canlı desteğe bağlanınız.</div>
          <div class="alert">Yatırım bonusunu alan üyeler yararlanamamaktadır. Yatırımınızın kayıbı sonrasında <span>talep edebilirsiniz.</span></div>
        </h5>

        <div class="alert alert-danger" style="background: var(--danger-color); text-align: center;" v-if="!_.isEmpty(error)">{{ error }}</div>

        <ButtonLoader style="width: 80%; margin: 0 auto; margin-top: 15px;" :loader="isLoading" @click.native="onSubmit" class="button primary" :text="'TALEP ET'">
          <template name="icon">
            <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
          </template>
        </ButtonLoader>
  </div>
</template>
<script>
  export default{
      props:['propType'],
      name: 'Request',
      metaInfo () {
        return {
          title: 'Request | ' + _.get(this.$store.getters['getClientMeta'], 'main.title', ''),
        }
      },
      created(){
      },
      data(){
        return{
          error: '',
          isLoading: false,
          type:'freebet',
          percent:null,
        }
      },
      computed:{
          user(){
            return this.$user();
          },
          user_detail(){
            return this.$user_detail();
          },
          config(){
            return this.$store.getters.getClientConfig;
          },
      },
      methods:{
        onSubmit(evt){
          if(!this.$user()){
              document.querySelector('.close-btn').click()
              this.$parent.bonus_modal = false
              this.$router.push({name: 'Login'});
              return false;
          }
          this.isLoading = true;
          axios.post('/user/request/' + this.propType, { type: this.type, percent : this.percent})
                .then((response)=>{
                  if(response.data.status){
                    this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
                  }else{
                    this.$store.dispatch('alert/message', { type: 'error', msg: response.data.message })
                  }
                  this.$parent.bonus_modal = false
              })
              .catch((err)=>{
                  this.error = err.response.data.message 
                  this.$parent.bonus_modal = false;
              })
              .finally(()=>{
                this.isLoading = false;
              })
        },
      }
  }
</script>


<style lang="scss">
  .request-page{
    h3{
      margin: 0px;
    }
  }
  #app.mobile{
      .bonus-modal{
          .content{
              height: 100% !important;
              max-height: none !important;
              border-radius: 0px !important;
              .button:not(.close-btn){
                  width: 100% !important;
                  height: 40px;
              }
          }
      }
  }
  .bonus-modal{
      .content{
          width: 520px !important;
          height: auto !important !important;
          color:#fff;
          .alert{
              text-align: left;
              background: rgb(255 255 255 / 8%);
              margin: 10px 0;
              font-weight: bold;
              span{
                  color: var(--client-c3)
              }
          }
          .close{
              display: none !important;
          }
          .button:not(.close-btn){
                height: 40px;
          }
          .close-btn{
              position: absolute;
              right: 10px;            
              width: 30px;
              top: 10px;
              border-radius: 100%;
              height: 30px;
              padding: 0px !important;
              svg{
                  width: 10px;
                  height: 10px;
              }    
          }
      }
  }
</style>